<script setup>
import { useDetectDevice } from '@/composables/device'

import BudgetDocumentsGrid from '@/components/accounting/BudgetDocumentsGrid.vue'
import BudgetDocumentsView from '@/components/accounting/BudgetDocumentsView.vue'

const { isMobile } = useDetectDevice()

</script>
<template>
  <budget-documents-view v-if="isMobile" />
  <budget-documents-grid v-else />
</template>
